import React from "react";

function SingleRotaryNonGMP() {
  return (
    <>
      <style>{`
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }
      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        margin-bottom: 20px;
      }
      .table {
        width: 100%;
        border-collapse: collapse;
        background: white;
      }
      .table-bordered {
        border: 1px solid #ddd;
      }
      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        font-size: 14px;
      }
      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      .table td:first-child {
        font-weight: 600;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>

        {/* Breadcrumb Section */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">
                    Single Rotary Tablet Press (Non-GMP)
                  </h1>
                  <div className="tj-page-link">
                    <span><i className="fa-solid fa-home"></i></span>
                    <span><a href="/">Home</a></span>
                    <span><i className="fa-solid fa-arrow-right"></i></span>
                    <span><span>Single Rotary Tablet Press (Non-GMP)</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="page-header-overlay"
            data-bg-image="assets/images/shape/pheader-overlay.png"
          ></div>
        </section>

        {/* MAIN CONTENT */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">

              {/* LEFT CONTENT */}
              <div className="col-lg-8">
                <div className="post-details-wrapper">

                  {/* MAIN IMAGE */}
                  <div className="blog-images wow fadeInUp" data-wow-delay=".1s">
                    <img
                      src="assets/images/SD_PHRMA_ALL_MIX _JPGS/11.png"
                      alt="Single Rotary Tablet Press Non-GMP"
                    />
                  </div>

                  <h2 className="title title-anim">
                    Single Rotary Tablet Press (Non-GMP)
                  </h2>

                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      The Single Rotary Tablet Press (Non-GMP) is engineered for
                      small and medium-scale production in industries such as
                      pharmaceuticals, chemicals, and nutraceuticals. It offers
                      a cost-effective solution with reliable performance and
                      simple operation.
                    </p>

                    <p className="wow fadeInUp" data-wow-delay=".4s">
                      Designed with a durable cast iron body, smooth rotary
                      operation, and easy-to-maintain components, this machine
                      ensures consistent tablet compression with minimal
                      maintenance requirements.
                    </p>
                  </div>

                  {/* EXTRA IMAGES */}
                  <div className="images-wrap">
                    <div className="row">

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".3s">
                          <img src="assets/images/SD_PHRMA_ALL_MIX _JPGS/12.png" alt="Image" />
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* TECHNICAL SPECIFICATIONS */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>

                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-14</td>
                          <td>DPM-16</td>
                          <td>DPM-20</td>
                          <td>DPM-23</td>
                          <td>DPM-27</td>
                          <td>DPM-30</td>
                        </tr>

                        <tr>
                          <td>Number of Stations</td>
                          <td>14</td>
                          <td>16</td>
                          <td>20</td>
                          <td>23</td>
                          <td>27</td>
                          <td>30</td>
                        </tr>

                        <tr>
                          <td>Output (Tablets / Hour)</td>
                          <td>6,300</td>
                          <td>7,200</td>
                          <td>9,000</td>
                          <td>10,350</td>
                          <td>12,150</td>
                          <td>13,500</td>
                        </tr>

                        <tr>
                          <td>Max Tablet Diameter</td>
                          <td>25 mm</td>
                          <td>25 mm</td>
                          <td>16 mm</td>
                          <td>16 mm</td>
                          <td>12 mm</td>
                          <td>12 mm</td>
                        </tr>

                        <tr>
                          <td>Max Depth of Fill</td>
                          <td>20 mm</td>
                          <td>20 mm</td>
                          <td>17 mm</td>
                          <td>17 mm</td>
                          <td>15 mm</td>
                          <td>15 mm</td>
                        </tr>

                        <tr>
                          <td>Main Compression Pressure</td>
                          <td>10 Tons</td>
                          <td>10 Tons</td>
                          <td>6.5 Tons</td>
                          <td>6.5 Tons</td>
                          <td>6 Tons</td>
                          <td>6 Tons</td>
                        </tr>

                        <tr>
                          <td>Turret Speed</td>
                          <td>15 RPM</td>
                          <td>15 RPM</td>
                          <td>15 RPM</td>
                          <td>15 RPM</td>
                          <td>15 RPM</td>
                          <td>15 RPM</td>
                        </tr>

                        <tr>
                          <td>Main Motor</td>
                          <td>2 HP</td>
                          <td>2 HP</td>
                          <td>2 HP</td>
                          <td>2 HP</td>
                          <td>2 HP</td>
                          <td>2 HP</td>
                        </tr>

                        <tr>
                          <td>Machine Dimensions (L × W × H)</td>
                          <td>800 × 600 × 1550 mm</td>
                          <td>850 × 650 × 1600 mm</td>
                          <td>850 × 650 × 1600 mm</td>
                          <td>850 × 650 × 1600 mm</td>
                          <td>850 × 650 × 1600 mm</td>
                          <td>850 × 650 × 1600 mm</td>
                        </tr>

                        <tr>
                          <td>Machine Weight</td>
                          <td>450 kg</td>
                          <td>500 kg</td>
                          <td>550 kg</td>
                          <td>600 kg</td>
                          <td>650 kg</td>
                          <td>700 kg</td>
                        </tr>

                      </tbody>
                    </table>
                  </div>

                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">

                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>
                    <ul>
                      <li>
                        <a href="/single-rotary-tablet-press">
                          Single Rotary Tablet Press (GMP)
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/double-side-rotary-tableting-machine">
                          Double Side Rotary Tableting Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/mini-tablet-press">
                          Mini Tablet Press
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                    </ul>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
    </>
  );
}

export default SingleRotaryNonGMP;
